import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["activeProps", "children", "exact", "to"];
import UIRouterButton from './UIRouterButton';
import useIsActive from './internal/useIsActive';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 *
 * A [`Button`](https://private.hubteamqa.com/foundations-components-storybook/?path=/docs/transitional-button--page)
 * type component with router support.
 * Supports `activeProps` for overriding the props when the button is active.
 */
export default function UIRouterNavButton(props) {
  const {
      activeProps,
      children,
      exact = false,
      to
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  const active = useIsActive(to, exact);
  return /*#__PURE__*/_jsx(UIRouterButton, Object.assign({}, rest, {
    to: to
  }, active ? activeProps : {}, {
    children: children
  }));
}